export const OffersModelsByAdvertiserSelectTranslationKeys = {
  settingsAffiliateModel: 'settings.affiliate-model',
  offerModelsOfferStatusIsInactive: 'offer.models-offer-status-is-inactive',
  offerModelsOfferStatusWorkingConditionsAreNotAccepted: 'offer.models-offer-status-working-conditions-are-not-accepted',
}
